module.exports = __webpack_public_path__ + "media/open-nav.c3a0fd38.mp3";